import Product from "../../../../../@types/Product"
import assets from "../../../../../assets"

// ID 1-19 X2
const ColoradoDesignSolidFrontSeatsX2: Product[] = [
    {
        id: 1,
        refId: 'BK03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-629-GY03',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.gunmetalGray,
    },
    {
        id: 2,
        refId: 'BL02',
        name: 'MadJax Colorado Premium, Admiral Blue',
        sku: '10-629-BL02',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.admiralBlue,
    },
    {
        id: 3,
        refId: 'BL09',
        name: 'MadJax Colorado Premium, Bolt Blue',
        sku: '10-629-BL09',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.boltBlue,
    },
    {
        id: 4,
        refId: 'GN06',
        name: 'MadJax Colorado Premium, Lime Green',
        sku: '10-629-GN06',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.limeGreen,
    },
    {
        id: 5,
        refId: 'GY03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-629-GY03',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.gunmetalGray,
    },
    {
        id: 6,
        refId: 'OR05',
        name: 'MadJax Colorado Premium, Vivid Orange',
        sku: '10-629-OR05',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.vividOrange,
    },
    {
        id: 7,
        refId: 'RD02',
        name: 'MadJax Colorado Premium, Cherry Red',
        img: assets.images.seatSwatches.cherryRed,
        sku: '10-629-RD02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 8,
        refId: 'RD06',
        name: 'MadJax Colorado Premium, Rosso Red',
        sku: '10-629-RD06',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.rossoRed,
    },
    {
        id: 9,
        refId: 'VL03',
        name: 'MadJax Colorado Premium, Amethyst Purple',
        sku: '10-629-VL03',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.amethystPurple,
    },
    {
        id: 10,
        refId: 'WH04',
        name: 'MadJax Colorado Premium, Frost White',
        sku: '10-629-WH04',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.frostWhite,
    },
    {
        id: 11,
        refId: 'YE02',
        name: 'MadJax Colorado Premium, Neon Yellow',
        sku: '10-629-YE02',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.neonYellow,
    },
    {
        id: 12,
        refId: 'BG02P',
        name: 'MadJax Colorado Premium, Sea Storm',
        img: assets.images.seatSwatches.seaStorm,
        sku: '10-629-BG02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 13,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado Light Graphite',
        sku: '10-560P',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.ltGraphite,
    },
    {
        id: 14,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado Ranch',
        sku: '10-563P',
        price: 0.00,
        retailPrice: 0.00,
        img: assets.images.seatSwatches.ranch,
        visible: false,
    },
]

const ColoradoDesignSolidRearSeatsX2: Product[] = [
    {
        id: 1,
        refId: 'BK03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-630-GY03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 2,
        refId: 'BL02',
        name: 'MadJax Colorado Premium, Admiral Blue',
        sku: '10-630-BL02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 3,
        refId: 'BL09',
        name: 'MadJax Colorado Premium, Bolt Blue',
        sku: '10-630-BL09',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 4,
        refId: 'GN06',
        name: 'MadJax Colorado Premium, Lime Green',
        sku: '10-630-GN06',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 5,
        refId: 'GY03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-630-GY03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 6,
        refId: 'OR05',
        name: 'MadJax Colorado Premium, Vivid Orange',
        sku: '10-630-OR05',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 7,
        refId: 'RD02',
        name: 'MadJax Colorado Premium, Cherry Red',
        sku: '10-630-RD02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 8,
        refId: 'RD06',
        name: 'MadJax Colorado Premium, Rosso Red',
        sku: '10-630-RD06',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 9,
        refId: 'VL03',
        name: 'MadJax Colorado Premium, Amethyst Purple',
        sku: '10-630-VL03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 10,
        refId: 'WH04',
        name: 'MadJax Colorado Premium, Frost White',
        sku: '10-630-WH04',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 11,
        refId: 'YE02',
        name: 'MadJax Colorado Premium, Neon Yellow',
        sku: '10-630-YE02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 12,
        refId: 'BG02P',
        name: 'MadJax Colorado Premium, Sea Storm',
        sku: '10-630-BG02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 13,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado G250/G300 Light Graphite',
        sku: '10-556P',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 14,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado G250/G300 Ranch',
        sku: '10-559P',
        price: 0.00,
        retailPrice: 0.00,
    }, 
]

// ID 1-19 X4
const ColoradoDesignSolidFrontSeatsX4: Product[] = [
    {
        id: 1,
        refId: 'BK03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-629-GY03',
        img: assets.images.seatSwatches.gunmetalGray,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/0f839e22-86f2-425d-bcf2-f5e1cc85ae00'
    },
    {
        id: 2,
        refId: 'BL02',
        name: 'MadJax Colorado Premium, Admiral Blue',
        sku: '10-629-BL02',
        img: assets.images.seatSwatches.admiralBlue,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c2d2edfc-4656-47d4-0538-981b482e9e00'
    },
    {
        id: 3,
        refId: 'BL09',
        name: 'MadJax Colorado Premium, Bolt Blue',
        sku: '10-629-BL09',
        img: assets.images.seatSwatches.boltBlue,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/412c1b6b-1a74-4956-32db-287fb7df8200'
    },
    {
        id: 4,
        refId: 'GN06',
        name: 'MadJax Colorado Premium, Lime Green',
        sku: '10-629-GN06',
        img: assets.images.seatSwatches.limeGreen,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/1cb7fa94-0c27-4d43-5f7e-f057c7e5f300'
    },
    {
        id: 5,
        refId: 'GY03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-629-GY03',
        img: assets.images.seatSwatches.gunmetalGray,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/0f839e22-86f2-425d-bcf2-f5e1cc85ae00'
    },
    {
        id: 6,
        refId: 'OR05',
        name: 'MadJax Colorado Premium, Vivid Orange',
        sku: '10-629-OR05',
        img: assets.images.seatSwatches.vividOrange,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/18544fb6-3c23-4cd2-4eab-30c07f900200'
    },
    {
        id: 7,
        refId: 'RD02',
        name: 'MadJax Colorado Premium, Cherry Red',
        img: assets.images.seatSwatches.cherryRed,
        sku: '10-629-RD02',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/2a3e8138-8b67-444e-28f0-509c45539800'
    },
    {
        id: 8,
        refId: 'RD06',
        name: 'MadJax Colorado Premium, Rosso Red',
        sku: '10-629-RD06',
        img: assets.images.seatSwatches.rossoRed,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/637b0432-4250-4f71-98d8-c105b52f3c00'
    },
    {
        id: 9,
        refId: 'VL03',
        name: 'MadJax Colorado Premium, Amethyst Purple',
        sku: '10-629-VL03',
        img: assets.images.seatSwatches.amethystPurple,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/ca394579-bdec-4017-4288-5c2f06277700'
    },
    {
        id: 10,
        refId: 'WH04',
        name: 'MadJax Colorado Premium, Frost White',
        sku: '10-629-WH04',
        img: assets.images.seatSwatches.frostWhite,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/4fa5da22-bd3e-451d-6b1d-78da77c83e00'
    },
    {
        id: 11,
        refId: 'YE02',
        name: 'MadJax Colorado Premium, Neon Yellow',
        sku: '10-629-YE02',
        img: assets.images.seatSwatches.neonYellow,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f0eba56c-a574-4000-f613-5a0c6269dd00'
    },
    {
        id: 12,
        refId: 'BG02P',
        name: 'MadJax Colorado Premium, Sea Storm',
        img: assets.images.seatSwatches.seaStorm,
        sku: '10-629-BG02',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/48f42d42-fa4f-4cca-9fbb-891a35548a00'
    },
    {
        id: 13,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado Light Graphite',
        sku: '10-560P',
        img: assets.images.seatSwatches.ltGraphite,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/23b047f7-59a4-49fb-b46d-0c605343a900'
    },
    {
        id: 14,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado Ranch',
        sku: '10-563P',
        img: assets.images.seatSwatches.ranch,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/0ed8e39a-2581-4803-d202-60b83ec6f100',
        visible: false,
    },
]

const ColoradoDesignSolidRearSeatsX4: Product[] = [
    {
        id: 1,
        refId: 'BK03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-630-GY03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 2,
        refId: 'BL02',
        name: 'MadJax Colorado Premium, Admiral Blue',
        sku: '10-630-BL02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 3,
        refId: 'BL09',
        name: 'MadJax Colorado Premium, Bolt Blue',
        sku: '10-630-BL09',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 4,
        refId: 'GN06',
        name: 'MadJax Colorado Premium, Lime Green',
        sku: '10-630-GN06',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 5,
        refId: 'GY03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-630-GY03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 6,
        refId: 'OR05',
        name: 'MadJax Colorado Premium, Vivid Orange',
        sku: '10-630-OR05',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 7,
        refId: 'RD02',
        name: 'MadJax Colorado Premium, Cherry Red',
        sku: '10-630-RD02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 8,
        refId: 'RD06',
        name: 'MadJax Colorado Premium, Rosso Red',
        sku: '10-630-RD06',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 9,
        refId: 'VL03',
        name: 'MadJax Colorado Premium, Amethyst Purple',
        sku: '10-630-VL03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 10,
        refId: 'WH04',
        name: 'MadJax Colorado Premium, Frost White',
        sku: '10-630-WH04',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 11,
        refId: 'YE02',
        name: 'MadJax Colorado Premium, Neon Yellow',
        sku: '10-630-YE02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 12,
        refId: 'BG02P',
        name: 'MadJax Colorado Premium, Sea Storm',
        sku: '10-630-BG02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 13,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado G250/G300 Light Graphite',
        sku: '10-556P',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 14,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado G250/G300 Ranch',
        sku: '10-559P',
        price: 0.00,
        retailPrice: 0.00,
    }, 
]


// ID 1-19 X6
const ColoradoDesignSolidFrontSeatsX6: Product[] = [
    {
        id: 1,
        refId: 'BK03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-629-GY03',
        img: assets.images.seatSwatches.gunmetalGray,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/251544d1-739d-409e-6b14-e5884eb9d500'
    },
    {
        id: 2,
        refId: 'BL02',
        name: 'MadJax Colorado Premium, Admiral Blue',
        sku: '10-629-BL02',
        img: assets.images.seatSwatches.admiralBlue,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/4c618f46-d620-42af-d517-9db119082f00'
    },
    {
        id: 3,
        refId: 'BL09',
        name: 'MadJax Colorado Premium, Bolt Blue',
        sku: '10-629-BL09',
        img: assets.images.seatSwatches.boltBlue,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/1eeec7ea-8770-433c-74c0-a8948db41f00'
    },
    {
        id: 4,
        refId: 'GN06',
        name: 'MadJax Colorado Premium, Lime Green',
        sku: '10-629-GN06',
        img: assets.images.seatSwatches.limeGreen,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f12feffb-750c-4a10-a3fb-92afc0e4e000'
    },
    {
        id: 5,
        refId: 'GY03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-629-GY03',
        img: assets.images.seatSwatches.gunmetalGray,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/251544d1-739d-409e-6b14-e5884eb9d500'
    },
    {
        id: 6,
        refId: 'OR05',
        name: 'MadJax Colorado Premium, Vivid Orange',
        sku: '10-629-OR05',
        img: assets.images.seatSwatches.vividOrange,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/693dd49e-b985-4dc1-708a-65123fe17400'
    },
    {
        id: 7,
        refId: 'RD02',
        name: 'MadJax Colorado Premium, Cherry Red',
        img: assets.images.seatSwatches.cherryRed,
        sku: '10-629-RD02',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/0a6fe8b2-a28f-46b5-07ba-1e7ee8536000'
    },
    {
        id: 8,
        refId: 'RD06',
        name: 'MadJax Colorado Premium, Rosso Red',
        sku: '10-629-RD06',
        img: assets.images.seatSwatches.rossoRed,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/02fc2835-2a55-4e67-abc3-7d324fd09500'
    },
    {
        id: 9,
        refId: 'VL03',
        name: 'MadJax Colorado Premium, Amethyst Purple',
        sku: '10-629-VL03',
        img: assets.images.seatSwatches.amethystPurple,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/885b27ca-4a5f-4fdd-699c-44f636caf800'
    },
    {
        id: 10,
        refId: 'WH04',
        name: 'MadJax Colorado Premium, Frost White',
        sku: '10-629-WH04',
        img: assets.images.seatSwatches.frostWhite,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/2c6273a1-e1f4-4f56-4824-d08a2e0eee00'
    },
    {
        id: 11,
        refId: 'YE02',
        name: 'MadJax Colorado Premium, Neon Yellow',
        sku: '10-629-YE02',
        img: assets.images.seatSwatches.neonYellow,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/23d9a80d-f9d2-4872-8846-c758a5fc4e00'
    },
    {
        id: 12,
        refId: 'BG02P',
        name: 'MadJax Colorado Premium, Sea Storm',
        img: assets.images.seatSwatches.seaStorm,
        sku: '10-629-BG02',
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/3b4fc5db-d146-4b5e-82f3-614ca5a4da00'
    },
    {
        id: 13,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado Light Graphite',
        sku: '10-560P',
        img: assets.images.seatSwatches.ltGraphite,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/18d8970d-d158-44d4-2c4f-aaf5a1dd8500'
    },
    {
        id: 14,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado Ranch',
        sku: '10-563P',
        img: assets.images.seatSwatches.ranch,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/443d1e12-f337-4b66-3005-d9f087f19400',
        visible: false,
    },
]

const ColoradoDesignSolidRearSeatsX6: Product[] = [
    {
        id: 1,
        refId: 'BK03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-630-GY03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 2,
        refId: 'BL02',
        name: 'MadJax Colorado Premium, Admiral Blue',
        sku: '10-630-BL02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 3,
        refId: 'BL09',
        name: 'MadJax Colorado Premium, Bolt Blue',
        sku: '10-630-BL09',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 4,
        refId: 'GN06',
        name: 'MadJax Colorado Premium, Lime Green',
        sku: '10-630-GN06',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 5,
        refId: 'GY03',
        name: 'MadJax Colorado Premium, Gunmetal Gray',
        sku: '10-630-GY03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 6,
        refId: 'OR05',
        name: 'MadJax Colorado Premium, Vivid Orange',
        sku: '10-630-OR05',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 7,
        refId: 'RD02',
        name: 'MadJax Colorado Premium, Cherry Red',
        sku: '10-630-RD02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 8,
        refId: 'RD06',
        name: 'MadJax Colorado Premium, Rosso Red',
        sku: '10-630-RD06',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 9,
        refId: 'VL03',
        name: 'MadJax Colorado Premium, Amethyst Purple',
        sku: '10-630-VL03',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 10,
        refId: 'WH04',
        name: 'MadJax Colorado Premium, Frost White',
        sku: '10-630-WH04',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 11,
        refId: 'YE02',
        name: 'MadJax Colorado Premium, Neon Yellow',
        sku: '10-630-YE02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 12,
        refId: 'BG02P',
        name: 'MadJax Colorado Premium, Sea Storm',
        sku: '10-630-BG02',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 13,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado G250/G300 Light Graphite',
        sku: '10-556P',
        price: 0.00,
        retailPrice: 0.00,
    },
    {
        id: 14,
        refId: [
            'BG02P',
            'BK03',
            'BL02',
            'BL09',
            'GN06',
            'GY03',
            'OR05',
            'RD02',
            'RD06',
            'VL03',
            'VL03',
            'YE02',
            'WH04'
        ],
        name: 'MadJax Colorado G250/G300 Ranch',
        sku: '10-559P',
        price: 0.00,
        retailPrice: 0.00,
    }, 
]

export {
    ColoradoDesignSolidFrontSeatsX2,
    ColoradoDesignSolidRearSeatsX2,
    ColoradoDesignSolidFrontSeatsX4,
    ColoradoDesignSolidRearSeatsX4,
    ColoradoDesignSolidFrontSeatsX6,
    ColoradoDesignSolidRearSeatsX6,
}